import * as Constants from '../constants';
import find from 'lodash/find';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
import isBoolean from 'lodash/isBoolean';
import includes from 'lodash/includes';

const is = (state, role) => {
  let user = state.user;
  return isObject(user)
      && isArray(user.roles)
      && includes(user.roles, role);
};

const can = (state, name, entityType = null, onlyOwned = null) => {
  let user = state.user;
  let criteria = {
    name,
  };
  if (entityType) {
    criteria['entityType'] = entityType;
  }
  if (isBoolean(onlyOwned)) {
    criteria['onlyOwned'] = onlyOwned;
  }
  return isObject(user)
      && isArray(user.abilities)
      && isObject(find(user.abilities, criteria));
};
const subscriptionDaysLeft = (state) => {
  if(!state.user) return null;

  let user = state.user;
  let subscriptionEndDate = user.subscriptionEndDate;
  if(subscriptionEndDate === null) {
    return null;
  }

  let now = (new Date()).getTime();
  let days = Math.floor((subscriptionEndDate * 1000 - now) / (1000 * 60 * 60 * 24));
  return days;
};

export default {
  isAuthorized(state) {
    return state.authorizationType !== Constants.UNAUTHORIZED;
  },
  isGuest(state) {
    return state.authorizationType !== Constants.AUTHORIZED_AS_USER;
  },
  isBCBA(state) {
    return is(state, Constants.ROLE_BCBA) || is(state, Constants.ROLE_INDEPENDENT_CURATOR);
  },
  isCurator(state) {
    return is(state, Constants.ROLE_CURATOR);
  },
  isTherapist(state) {
    return is(state, Constants.ROLE_THERAPIST);
  },
  isClient(state) {
    return is(state, Constants.ROLE_CLIENT);
  },
  isPreviousDateSession(state) {
    return state.isPreviousDateSession;
  },
  previousDate(state) {
    return state.previousDate;
  },
  previousTime(state) {
    return state.previousTime;
  },
  previousDuration(state) {
    return state.previousDuration;
  },
  isMensurationForbidden(state) {
    return state.user ? state.user.isMensurationForbidden : false;
  },
  isSubscriptionExpiredSoon(state) {
    let daysLeft = subscriptionDaysLeft(state);
    return daysLeft !== null && daysLeft <= Constants.SUBSCRIPTION_MIN_DAYS_LEFT_FOR_WARNING;
  },
  subscriptionDaysLeft(state) {
    return subscriptionDaysLeft(state);
  },
  canViewCurators(state) {
    return can(state, 'view_curators');
  },
  canViewCurator(state) {
    return can(state, 'view_curator');
  },
  canViewTherapists(state) {
    return can(state, 'view_therapists');
  },
  canViewTherapist(state) {
    return can(state, 'view_therapist');
  },
  canViewClients(state) {
    return can(state, 'view_clients');
  },
  canViewClient(state) {
    return can(state, 'view_client');
  },
  canCreateCurator(state) {
    return can(state, 'create_curator');
  },
  canUpdateCurator(state) {
    return can(state, 'update_curator');
  },
  canDeleteCurator(state) {
    return can(state, 'delete_curator');
  },
  canCreateTherapist(state) {
    return can(state, 'create_therapist');
  },
  canUpdateTherapist(state) {
    return can(state, 'update_therapist');
  },
  canDeleteTherapist(state) {
    return can(state, 'delete_therapist');
  },
  canCreateClient(state) {
    return can(state, 'create_client');
  },
  canUpdateClient(state) {
    return can(state, 'update_client');
  },
  canDeleteClient(state) {
    return can(state, 'delete_client');
  },
  canStatisticReportListView(state) {
    return can(state, 'statistic_report_list_view');
  },
  user(state) {
    return state.user;
  },

  clientId(state) {
    return state;
  },

};



// WEBPACK FOOTER //
// ./src/common/auth/vuex/getters.js